import {
  fetchDevices,
  fetchDevice,
  updateFormula,
  updateTarget,
  updateGroup,
  updateDevice,
} from '../actions/deviceActions';
import { Group } from './groupReducers';

export interface Formula {
  id: number;
  sensor_id: number;
  constant: number;
  converter: number;
  cable_length: number;
}

export interface Target {
  id: number;
  name: string;
  type: string;
  latitude: number;
  longitude: number;
}

export interface Device {
  serial: string;
  device_key: string;
  type: string;
  target_id: number;
  target: Target;
  group: Group;
  formula: Formula;
  is_active: boolean;
  reporting_in_hours?: number;
  sampling_in_hours?: number;
  version?: string;
}

const initialState = {
  devices: [] as Device[],
};

export const device = (state = initialState, action) => {
  switch (action.type) {
    case fetchDevices.success:
      return {
        ...state,
        devices: action.payload,
      };
    case fetchDevice.success:
      return {
        ...state,
        devices: [
          ...state.devices.filter((device) => device.serial !== action.payload.serial),
          action.payload,
        ],
      };
    case updateDevice.success:
      return {
        ...state,
        devices: state.devices.map((device) =>
          device.serial === action.payload.serial ? { ...device, ...action.payload } : device,
        ),
      };
    case updateFormula.type:
      return {
        ...state,
        devices: state.devices.map((device) =>
          device.serial === action.payload.serial
            ? { ...device, formula: { ...device.formula, ...action.payload.formula } }
            : device,
        ),
      };
    case updateTarget.type:
      return {
        ...state,
        devices: state.devices.map((device) =>
          device.serial === action.payload.serial
            ? { ...device, target: { ...device.target, ...action.payload.target } }
            : device,
        ),
      };
    case updateGroup.type:
      return {
        ...state,
        devices: state.devices.map((device) =>
          device.serial === action.payload.serial
            ? { ...device, group: { ...device.group, ...action.payload.group } }
            : device,
        ),
      };
    default:
      return state;
  }
};
